import { MessagesInboxClient } from './messages-inbox-client';

export const metadata = { title: 'Messages | Seller' };

export default function Page() {
  return <MessagesInboxClient />;
}
